import React, { ChangeEvent, useCallback, useEffect, useRef } from 'react';
import Prompt from 'src/app/components/Prompt/Prompt';
import { ROUTES } from 'src/app/constants';
import styles from './Footer.module.scss';
import SendButton from '../SendButton/SendButton';
import { t } from 'i18next';

type FooterPropType = {
  prompt?: string;
  conversationId?: number;
  onPromptInputChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onPromptSend?: (event?: string) => void;
  disablePrompt?: boolean;
  hiddenWithDisabledFocus?: boolean;
};

function Footer(props: FooterPropType) {
  const {
    prompt,
    conversationId,
    disablePrompt,
    onPromptInputChange,
    onPromptSend,
    hiddenWithDisabledFocus,
  } = props;

  const footerRef = useRef<HTMLDivElement>(null);

  const triggerSend = useCallback(
    (event: React.FormEvent<HTMLFormElement> | ChangeEvent<EventTarget>) => {
      event.preventDefault();
      if (!prompt?.trim()) return;
      const eventType = event.type === 'submit' ? 'type' : (event.type as string);
      onPromptSend?.(eventType);
    },
    [onPromptSend, prompt]
  );

    useEffect(() => {
      const footer = footerRef.current;
      if (!footer) return;
      footer.inert = Boolean(hiddenWithDisabledFocus);
    }, [hiddenWithDisabledFocus]);

  return (

    <div ref={footerRef} className='footer-section' aria-hidden={hiddenWithDisabledFocus} tabIndex={-1}>
      <div className={'flex items-center mt-space-5 mb-space-4'}>
        <Prompt
          handlePromptInput={onPromptInputChange}
          promptValue={prompt}
          onSubmit={triggerSend}
          disabled={disablePrompt}
        ></Prompt>
        <SendButton className='flex-none' onClickHandler={triggerSend} isDisabled={!prompt} />
      </div>
      <div className={styles.footerContainer}>
        <div className='mt-space-2 text-center'>
          <p className='text-gray6D text-body-small'>
            {t('INACCURATE_AI')}
            <a
              className='underline text-hyperlink hover:text-blue-800'
              target='_blank'
              rel='noopener noreferrer'
              href={ROUTES.EXTERNAL.FOOTER_FAQ}
              aria-label={t('FAQ_FULL')}
            >
              {t('FAQS')}
            </a>
          </p>
          {/** NOTE: only for debug purpose */}
          {conversationId && (
            <div className='font-inter-semiBold text-center text-xs'>
              {t('CONVERSATION_ID')}: {conversationId}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Footer;
